import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  class: "modal_btns center",
  style: {"gap":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.props.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal_bg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.fnEvent(false))),
          style: _normalizeStyle({ display: $setup.props.show ? 'block' : 'none' })
        }, null, 4))
      : _createCommentVNode("", true),
    ($setup.props.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "modal_layer text_modal",
          id: "cert_modal",
          style: _normalizeStyle({ display: $setup.props.show ? 'block' : 'none' })
        }, [
          _createElementVNode("p", {
            class: "modal_txt",
            innerHTML: $props.content
          }, null, 8, _hoisted_1),
          _createElementVNode("div", _hoisted_2, [
            ($setup.props.yes)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn_blue",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.fnEvent(true)))
                }, _toDisplayString($setup.props.yes), 1))
              : _createCommentVNode("", true),
            ($setup.props.no)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn_blue",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.fnEvent(false)))
                }, _toDisplayString($setup.props.no), 1))
              : _createCommentVNode("", true)
          ])
        ], 4))
      : _createCommentVNode("", true)
  ], 64))
}